import { cleanSourceText, normalizePlacspLotOf } from '@tenders/shared';
import { countryConfig } from '../country';

/**
 * MiLicita: PLACSP text as a Spanish page prints it — HTML entities an editor pasted
 * into a title decoded («para el&nbsp;Servicio» printed verbatim on 40 live lots,
 * 2026-10-21) and the «Lote 005 de 3 del expediente» numbering repaired. The adapter
 * does both on write since 2026-10-21; this covers the rows stored before, until
 * `services/api/scripts/es-fix-lot-text.sql` has run. Identity on UZ and KZ, whose
 * output must not change. The prerender's row mapper has its own twin
 * (`prerender-row.ts`), because it cannot import the app's country module.
 */
export const displaySourceText: (s: string) => string =
  countryConfig.code === 'es' ? (s) => normalizePlacspLotOf(cleanSourceText(s)) : (s) => s;
